import Qs from "qs";
import { GMX_STATS_BASE_URL } from "config/backend";
// Make requests to CryptoCompare API
export async function makeApiRequest(path) {
	try {
		// const response = await fetch(`https://min-api.cryptocompare.com/${path}`);
    // https://hj-fantom-gateway.wzjo2o.com/ws/kline/candles/btcusdt?period=4h
		// const response = await fetch(`https://hj-fantom-gateway.wzjo2o.com/ws/kline/candles/${path}`);

		// /fantom_api/ws/kline/candles/ftmusdt?preferableChainId=4002&preferableSource=fast&period=1m
		// /fantom_api/ws/kline/candles/ftmusdt?preferableChainId=4002&preferableSource=fast&period=4h
		const response = await fetch(`${GMX_STATS_BASE_URL}/ws/kline/candles/${path}`);
		const json = await response.json();
		let prices = json?.prices;
		console.log("helper-json=", json)
		return prices;
	} catch (error) {
		throw new Error(`CryptoCompare request error: ${error.status}`);
	}
}
export async function makeApiInitRequest(path, options = {}, method="POST") {
	try {
		// options = {
		// 	"symbol":"ftmusdt",
		// 	"kType":"1day"
		// }
		let requestOptions = {
			method,
			headers: { 
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			// body: JSON.stringify(options)
			body: Qs.stringify(options)
		};
		// let test = await fetch('/fantom_api/ws/kline/candles/ftmusdt?preferableChainId=4002&preferableSource=fast&period=4h');
		let test = await fetch(`${GMX_STATS_BASE_URL}/ws/${path}`, requestOptions);
		let json = await test.json();
		let prices = json?.data;
		return prices
	} catch (error) {
		throw new Error(`CryptoCompare request error: ${error.status}`);
	}
}

// Generate a symbol ID from a pair of the coins
export function generateSymbol(exchange, fromSymbol, toSymbol) {
	const short = `${fromSymbol}/${toSymbol}`;
	return {
		short,
		full: `${exchange}:${short}`,
	};
}

export function parseFullSymbol(fullSymbol) {
	const match = fullSymbol.match(/^(\w+):(\w+)\/(\w+)$/);
	if (!match) {
		return null;
	}

	return {
		exchange: match[1],
		fromSymbol: match[2],
		toSymbol: match[3],
	};
}
